import {Company} from './company';

export class Subscription {
    id: number;
    company_id: number;
    company: Company;
    afas_article_id: string;
    item_id: string;
    description: string;
    comment: string;
    count_url: string;
    count: number;
    price: number;
    last_date: Date;
    repeat: 'quarter' | 'month' | 'year';
}
